/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventFreeNftDetailRequest model module.
 * @module model/EventsControllerDtoEventFreeNftDetailRequest
 * @version 1.0
 */
class EventsControllerDtoEventFreeNftDetailRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventFreeNftDetailRequest</code>.
     * @alias module:model/EventsControllerDtoEventFreeNftDetailRequest
     */
    constructor() { 
        
        EventsControllerDtoEventFreeNftDetailRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventFreeNftDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventFreeNftDetailRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventFreeNftDetailRequest} The populated <code>EventsControllerDtoEventFreeNftDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventFreeNftDetailRequest();

            if (data.hasOwnProperty('freenftNo')) {
                obj['freenftNo'] = ApiClient.convertToType(data['freenftNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventFreeNftDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventFreeNftDetailRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} freenftNo
 */
EventsControllerDtoEventFreeNftDetailRequest.prototype['freenftNo'] = undefined;






export default EventsControllerDtoEventFreeNftDetailRequest;

